import { NoteText } from "@/i18n/NoteText";
import { abbreviateName, formatNoteDate } from "@/lib/noteFormat";

// Field Notes (Internal — from technicians). Read-only accordion of
// notes captured by techs in the field. Hidden when there are none.
// Extracted from WorkOrderTab.jsx (Feb 2026, iter180).
export function WOFieldNotes({ editingWO }) {
  const notes = editingWO?.field_notes || [];
  if (notes.length === 0) return null;

  return (
    <details className="border border-slate-200 rounded-lg" data-testid="wo-field-notes-section">
      <summary className="px-3 py-2 text-xs font-semibold text-slate-600 cursor-pointer hover:bg-slate-50 flex items-center gap-2">
        Field Notes ({notes.length})
      </summary>
      <div className="px-3 pb-3 space-y-2">
        {notes.map((n, i) => (
          <div key={n.id || i} className="bg-amber-50 rounded-lg p-2.5 border border-amber-200 text-sm">
            <div className="text-slate-800"><NoteText note={n} /></div>
            <div className="flex items-center justify-between mt-1.5 pt-1 border-t border-amber-200/50 text-[10px]">
              <span className="font-semibold text-blue-600">{abbreviateName(n.tech_name || n.created_by)}</span>
              <span className="text-slate-400">{formatNoteDate(n.created_at)}</span>
            </div>
          </div>
        ))}
      </div>
    </details>
  );
}
